export default "__VITE_ASSET__80ea8e71__"